"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuBase = exports.Menu = void 0;
var tslib_1 = require("tslib");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");
var react_1 = tslib_1.__importStar(require("react"));
var context_1 = require("./context");
var root_1 = require("./styled/root");
var Menu = (0, react_1.forwardRef)(function (_a, ref) {
    var __UIScope = _a.__UIScope, testID = _a["data-testid"], children = _a.children, className = _a.className, id = _a.id, isDismissible = _a.isDismissible, isInline = _a.isInline, isInverse = _a.isInverse, isShowing = _a.isShowing, onClose = _a.onClose, onItemSelected = _a.onItemSelected, style = _a.style, _b = _a.pattern, pattern = _b === void 0 ? 'list' : _b;
    var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
        block: 'Menu',
        className: className,
        __UIScope: __UIScope,
    }).rootClasses;
    var contextValue = (0, react_1.useMemo)(function () { return ({
        isShowing: isShowing,
        onClose: onClose,
        onItemSelected: onItemSelected,
        isDismissible: isDismissible,
        isInverse: isInverse,
        hasTriggerElement: react_1.Children.count(children) > 1,
        pattern: pattern,
    }); }, [
        isShowing,
        onClose,
        onItemSelected,
        isDismissible,
        isInverse,
        children,
        pattern,
    ]);
    return (react_1.default.createElement(root_1.Root, { isInline: isInline, className: rootClasses, "data-testid": testID, id: id, ref: ref, style: style },
        react_1.default.createElement(context_1.MenuContext.Provider, { value: contextValue }, children)));
});
exports.MenuBase = Menu;
var MenuWithSpace = (0, ui_helper_with_space_1.withSpace)(Menu);
exports.Menu = MenuWithSpace;
Menu.displayName = 'Menu';
//# sourceMappingURL=menu.js.map